import React from 'react';
import Joi from 'joi';

import { connect } from 'react-redux';
import { loadDivisions } from '../../store/divisions';
import { SelectOption } from '../../utils/models';

import Form from '../common/form';
import Progress from '../themed/progress';

import * as projectService from '../../services/projectService';
import * as toastService from '../../services/toastService';
import * as utils from '../../utils/utilities';

class CreateNewInspectionType extends Form {
	state = {
		data: {
            inspectionName: "",
            inspectionCode: "",
			divisionIds: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
        inspectionName: Joi.string().required().label("Inspection Type Name"),
        inspectionCode: Joi.string().required().label("Inspection Type Code"),
        divisionIds: Joi.array().items().min(1).required().label("Divisions"),
	};

	componentDidMount(): void {
		this.props.loadDivisions();
	}

	getApiData = () => {
		return {
			inspectionName: this.state.data.inspectionName,
            inspectionCode: this.state.data.inspectionCode,
			divisionIds: this.state.data.divisionIds.map((division: SelectOption) => division.id),
		}
	}

	postData = async (): Promise<void> => {
		const apiData = this.getApiData();

        await projectService.createInspectionType(apiData, this.handleProgressChange);
		window.location.reload();
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Creating Inspection Type',
			success: 'Inspection Type Created',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
					<h1 className="form-title">Create a new inspection type</h1>

					<div className="container">
                        <div className="row">
                            <div className="col">
                                {this.renderInput({
                                    type: "text",
                                    name: 'inspectionName',
                                    label: 'Inspection Type Name',
                                    placeholder: 'Enter Inspection Type Name',
                                })}
                            </div>

                            <div className="col">
                                {this.renderInput({
                                    type: "text",
                                    name: 'inspectionCode',
                                    label: 'Inspection Type Code',
                                    placeholder: 'Enter Inspection Type Code e.g EFVIP',
                                })}
                            </div>
                        </div>

						{this.renderMultiSelect({
							options: this.props.divisions,
							name: 'divisionIds',
							placeholder: 'Select divisions',
							label: 'Divisions',
							showCheckbox: true,
							loading: this.props.loading,
						})}
                    </div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Create')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		loading: state.divisions.loading,
		divisions: state.divisions.list.map(utils.transformDivisionItem),
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		loadDivisions: () => dispatch(loadDivisions()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewInspectionType);
